import { createApp } from 'vue'
import App from './App.vue'

import '@/assets/css/index.css'

// 导入并配置Pinia
import { setupPinia } from './store'

// 导入store初始化函数
import { initializeStores } from './store/modules'

// 导入版本缓存管理工具
import { initVersionCheck } from './utils/versionCache'

// 导入错误处理工具
import { setupGlobalErrorHandlers } from './utils/errorHandler'

// 导入并配置路由
import { setupRouter } from './router'

// 导入全局组件注册
import { registerGlobalComponents } from './components/global'

async function bootstrap() {
  const app = createApp(App)

  // 设置Pinia
  setupPinia(app)

  // 初始化所有store - 确保在路由之前初始化
  await initializeStores()

  // 配置路由
  setupRouter(app)

  // 注册全局组件
  registerGlobalComponents(app)

  // 注册全局错误处理
  setupGlobalErrorHandlers()

  // 初始化版本检查，如果版本更新则清空缓存
  initVersionCheck()

  app
    .mount('#app')
    .$nextTick(() => {
      postMessage({ payload: 'removeLoading' }, '*')
    })
}

// 启动应用
bootstrap().catch((error) => {
  console.error('Failed to bootstrap the application:', error)
})
